/**
 *
 */
function initCrcAccountToggle() {
  const accountDropdownButton = document.querySelector('.site-header__main__site-account-toggle');
  const accountDropdown = document.querySelector('.site-header__main__site-account-dropdown');
  const wrapper = document.body;
  const mobileButton = document.getElementById('mobile-menu-toggle');

  /**
   * Toggles the account menu open and closed.
   */
  const toggleAccountMenu = () => {
    accountDropdownButton.classList.toggle('account-dropdown-expanded');
    accountDropdown.classList.toggle('account-dropdown-open');
    accountDropdown.setAttribute(
      'aria-expanded',
      accountDropdown.getAttribute('aria-expanded') === 'true' ? 'false' : 'true',
    );
  };

  if (accountDropdownButton) {
    accountDropdownButton.addEventListener('click', () => {
      if (wrapper.classList.contains('mobile-nav-open')) {
        wrapper.classList.toggle('mobile-nav-open');
        wrapper.classList.toggle('lock-scrolling');
        mobileButton.setAttribute(
          'aria-expanded',
          mobileButton.getAttribute('aria-expanded') === 'true' ? 'false' : 'true',
        );
      }
      accountDropdownButton.classList.toggle('account-dropdown-expanded');
      accountDropdown.classList.toggle('account-dropdown-open');
      accountDropdown.setAttribute(
        'aria-expanded',
        accountDropdown.getAttribute('aria-expanded') === 'true' ? 'false' : 'true',
      );
    });
    accountDropdownButton.addEventListener('mouseenter', () => toggleAccountMenu());
    accountDropdownButton.addEventListener('mouseleave', () => toggleAccountMenu());
    accountDropdown.addEventListener('mouseleave', () => toggleAccountMenu());
  }
  if (mobileButton) {
    mobileButton.addEventListener('click', () => {
      if (accountDropdownButton.classList.contains('account-dropdown-expanded')) {
        accountDropdownButton.classList.toggle('account-dropdown-expanded');
        accountDropdown.classList.toggle('account-dropdown-open');
        accountDropdown.setAttribute(
          'aria-expanded',
          accountDropdown.getAttribute('aria-expanded') === 'true' ? 'false' : 'true',
        );
      }
    });
  }
}
window.addEventListener('load', () => {
  initCrcAccountToggle();
});
